import React from 'react';
import { EcoClub5Class2025 } from '../views';


const AccountGeneralPage = () => {
  return <EcoClub5Class2025/>;
};

export default AccountGeneralPage;